import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Sortable = props => (
  <SvgIcon
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12,17.5455844 L15.2526912,14.2928932 C15.6432155,13.9023689 16.2763805,13.9023689 16.6669048,14.2928932 C17.057429,14.6834175 17.057429,15.3165825 16.6669048,15.7071068 L12.7071068,19.6669048 C12.3165825,20.057429 11.6834175,20.057429 11.2928932,19.6669048 L7.33309524,15.7071068 C6.94257095,15.3165825 6.94257095,14.6834175 7.33309524,14.2928932 C7.72361954,13.9023689 8.35678451,13.9023689 8.74730881,14.2928932 L12,17.5455844 Z"
      fill="currentcolor"
      fillRule="nonzero"
    />
    <path
      d="M12,6.41421356 L8.74730881,9.66690476 C8.35678451,10.057429 7.72361954,10.057429 7.33309524,9.66690476 C6.94257095,9.27638046 6.94257095,8.64321549 7.33309524,8.25269119 L11.2928932,4.29289322 C11.6834175,3.90236893 12.3165825,3.90236893 12.7071068,4.29289322 L16.6669048,8.25269119 C17.057429,8.64321549 17.057429,9.27638046 16.6669048,9.66690476 C16.2763805,10.057429 15.6432155,10.057429 15.2526912,9.66690476 L12,6.41421356 Z"
      fill="currentcolor"
      fillRule="nonzero"
    />
  </SvgIcon>
);

export default Sortable;
